<template>
  <ul class="list-unstyled">
    <li :class="$style.item">
      <div :class="$style.itemTime" class="mr-3">25.12</div>
      <div :class="$style.itemSeparator">
        <div :class="[$style.donut, $style.primary]" class="mr-3"/>
      </div>
      <div>
        Katolički Božić
        <p>Odsustvo 19 zaposlenih</p>
      </div>
    </li>
    <li :class="$style.item">
      <div :class="$style.itemTime" class="mr-3">26.12</div>
      <div :class="$style.itemSeparator">
        <div :class="[$style.donut, $style.primary]" class="mr-3"/>
      </div>
      <div>
        Katolički Božić
        <p>Odsustvo 19 zaposlenih</p>
      </div>
    </li>

    <li :class="$style.item">
      <div :class="$style.itemTime" class="mr-3">01.01</div>
      <div :class="$style.itemSeparator">
        <div :class="[$style.donut, $style.danger]" class="mr-3"/>
      </div>
      <div>
        Nova godina
        <p>Neradni dan</p>
      </div>
    </li>
    <li :class="$style.item">
      <div :class="$style.itemTime" class="mr-3">02.01</div>
      <div :class="$style.itemSeparator">
        <div :class="[$style.donut, $style.danger]" class="mr-3"/>
      </div>
      <div>
        Nova godina
        <p>Neradni dan</p>
      </div>
    </li>

  </ul>
</template>
<script>
export default {
  name: 'KitList19v1',
}
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>
